import z from 'zod';

export type ExitFromParkingFormSchemaValues = z.infer<typeof exitFromParkingFormSchema>;
export const exitFromParkingFormSchema = z.object({
    exit_gateway: z.string().nonempty(),
    open_gateway: z.boolean(),
});
